class Mobile_Menu {
	constructor() {
		this.selectors = {
			document: document,			
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
		const mobileLinks = document.querySelectorAll('#header_mobile .has_child .has_child_link');
        const mobileLinksArrow = document.querySelectorAll('.has_child .icon1-arrow-down');	
		mobileLinks.forEach((el) => {
			el.addEventListener('click', e => {
				e.preventDefault();											
			})
		});
        mobileLinksArrow.forEach((el) => {
			el.addEventListener('click', e => {				
				const $this = $(e.currentTarget);				
				$this.toggleClass('rotate');
				$this.next().toggleClass('show');
			})
		})
    }
}
new Mobile_Menu();